import { sendRequest } from "../../hooks/requests/useRequest";

export async function ValidateSend({
    nim,id_user,id_process,id_work_order,id_branch
}) {
    const body = {
         nim,id_user,id_process,id_work_order,id_branch
    };

    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(body)
    };

    const response = await sendRequest(
        requestOptions, "Tracking/SendSampligs"
    );

    if (response.code === 200)
        return {
            code: response.code,
            data: response?.data
        }
    else if (response.code === 401)
        return response.code;
    else
        return {
            code: response.code,
            data: response?.data
        }
}


export async function InfoPatient({
    nim,id_departament
}) {
    const body = {
         nim,id_departament
    };

    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(body)
    };

    const response = await sendRequest(
        requestOptions, "Sass/PatientSendSample"
    );

    if (response.code === 200)
        return {
            code: response.code,
            data: response?.data
        }
    else if (response.code === 401)
        return response.code;
    else
        return {
            code: response.code,
            data: response?.data
        }
}


export async function sendSamplings(
    _array,
) {
   
   const transformedData = _array.map(item => ({
        nim: item?.nim,
        id_branch: item?.id_branch,
        id_work_order: item?.id_work_order, 
        id_work_order_exam: item?.id_work_order_exam ?? 0, 
        is_send1: item.is_send1 || false, 
        is_send2: item.is_send2 || false, 
        check_forwarded: item.check_forwarded || false, 
        process: item.process || 0, 
        children: item.children ? item.children.map(child => ({
            id_work_order_exam: child.id, 
            is_send1: child.is_send1 || false,
            is_send2: child.is_send2 || false,
            refused_check_specimen: child.refused_check_specimen || false,
            valueDontSend: child.valueDontSend || 0,
            id_return_reason: 0,
            check_specimen: child.check_specimen || false,
        })) : [],
        is_proccess_sample: item.is_proccess_sample
    }));

    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(transformedData),
    };
    const response = await sendRequest(
        requestOptions, "Sass/AcceptTracking"
    );

    if (response.code === 200)
        return {
            code: response.code,
            data: response?.data
        }
    else if (response.code === 401)
        return response.code;
    else
        return {
            code: response.code,
            data: response?.data
        }
}


export async function getAllTracking (_idUsers,_proces,_id_branch)
{
    const requestOptions = {
        method: "GET",
    };

    const response = await sendRequest(requestOptions, `Tracking/DetailNimTracking/${_idUsers}/${_proces}/${_id_branch}`);

   if (response.code === 200)
        return {
            code: response.code,
            data: response?.data
        }
    else if (response.code === 401)
        return response.code;
    else
        return {
            code: response.code,
            data: response?.data
        }
}




